import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/Grace";

const Og9 = () => { 
  const project_id = "PRJ00082";
  const title = "Grace Gardens - Ngong"; 

  const mapConfig = {
    minZoom: 14,
    zoom: 15,
    bounds: [
      [-1.336, 36.608],
      [-1.353, 36.622],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={project_id}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/properties/the-great-oasis-gardens-nanyuki/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSfkovo3n5xt2iggBTQeHIaa98TI6-XbUXTPeTBc2XoGLdRwOg/viewform"
    />
  );
};

export default Og9; // Exporting as default, so name change is local
